import { useState, useEffect } from 'react';

const MIN_RESPONSIVE_WIDTH = 1800;

export const useResponsivePanel = () => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(window.innerWidth <= MIN_RESPONSIVE_WIDTH);

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      if (newWidth <= MIN_RESPONSIVE_WIDTH && !isCollapsed) {
        setIsCollapsed(true);
      } else if (newWidth > MIN_RESPONSIVE_WIDTH && isCollapsed) {
        setIsCollapsed(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isCollapsed]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return { isCollapsed, toggleCollapse };
};
